import { Window } from '@progress/kendo-react-dialogs';
import { WindowActionsBar } from '@progress/kendo-react-dialogs';
import { InputChangeEvent, TextArea, TextAreaChangeEvent } from '@progress/kendo-react-inputs';
import { DealerGroup } from '../../../../Models/DealerGroup';
import { MultiSelect, MultiSelectChangeEvent } from '@progress/kendo-react-dropdowns';
import styles from './_dealer-group-editor-dialog.module.scss';
import { NiadaUser, User } from '../../../../Models/User';
import { useState } from 'react';
import { Field, Form, FormElement, FormRenderProps } from '@progress/kendo-react-form';
import { FormInput } from '@amsanalytics/react-shared-library';
export interface IDealerGroupEditorProps {
  dealerGroup: DealerGroup | null;
  businessTypes: any[];
  moderators: NiadaUser[];
  onCancel: () => void;
  onSubmit: (dealerGroup: DealerGroup) => void;
}
// type DealerEditInfo = Omit<DealerGroup, 'id' | 'dataStatus'> & { id?: string };
export default function DealerGroupEditorDialog(props: IDealerGroupEditorProps) {
  const [dealerGroupEditInfo, setDealerGroupEditInfo] = useState<DealerGroup>(props.dealerGroup
    ? { ...props.dealerGroup } as DealerGroup
    : {
      name: '',
      description: '',
      sortOrder: 1,
      moderatorIds: [],
      businessTypeIds: [],
      createdDate: new Date()
    } as DealerGroup);
  const initialValues = { dealerGroupName: dealerGroupEditInfo.name }
  return (
    <div className={styles.dealerGroupEditorDialogContainer}>
      <Window width={600} height={450} title={dealerGroupEditInfo.id ? `Edit ${dealerGroupEditInfo.name}` : 'Create Dealer'} modal={true}>
        <div
          style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            border: '1px solid rgba(0, 0, 0, 0.08)',
            padding: '10px',
            marginRight: '5px',
          }}
        >

          <Form
            initialValues={initialValues}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: '100%' }}>
                <fieldset className={"k-form-fieldset"}>
                  <legend className={"k-form-legend"} style={{ marginBottom: '0px' }} >
                    <span style={{ fontWeight: '500' }}>{'Dealer Group'}</span>
                  </legend>
                </fieldset>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%' }}>
                    <Field
                      style={{ width: '100%' }}
                      fieldWrapperStyle={{ width: '100%' }}
                      formFieldWrapperStyle={{ width: '100%' }}
                      name="dealerGroupName"
                      id="dealerGroupName"
                      type="text"
                      // useFloatingLabel={true}
                      label="Dealer Group Name *"
                      value={dealerGroupEditInfo.name!}
                      onChange={(event: InputChangeEvent) => {
                        setDealerGroupEditInfo({
                          ...dealerGroupEditInfo,
                          name: event.value
                        });
                      }}
                      component={FormInput}
                      required={true}
                      validator={(value: any, valueGetter: (name: string) => any, fieldProps: { name: string }, required?: boolean) => {
                        return value?.length > 0 ? undefined : `Dealer Group Name is required`;;
                      }}
                    />
                    <div
                      style={{ marginTop: '10px' }}>
                      Description
                    </div>
                    <TextArea
                      title='Description'
                      placeholder="Description..."
                      value={dealerGroupEditInfo.description}
                      onChange={(event: TextAreaChangeEvent) => {
                        setDealerGroupEditInfo({
                          ...dealerGroupEditInfo,
                          description: event.value
                        });
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginTop: '10px'
                    }}
                  >
                    <MultiSelect
                      data={props.businessTypes}
                      onChange={(event: MultiSelectChangeEvent) => {
                        setDealerGroupEditInfo(
                          {
                            ...dealerGroupEditInfo,
                            businessTypeIds: event.target.value.map(bt => bt.id)
                          }
                        );
                      }}
                      dataItemKey='id'
                      value={props.businessTypes.filter(bt => dealerGroupEditInfo.businessTypeIds.includes(bt.id))}
                      fillMode='outline'
                      textField="name"
                      placeholder='Type(s)'
                      label='Type(s)'
                      style={{ width: '100%' }}
                    />

                    {/* <ComboBox
                      data={Array.from({ length: 30 }, (_, i) => i + 1).map(day => { return { name: day } })}
                      label="Due Day"
                      textField="name"
                      style={{ width: '100px' }}
                    /> */}
                  </div>
                  {/* <div style={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%' }}>
                    <div style={{ marginTop: '10px' }}>
                      Notes
                    </div>
                    <TextArea placeholder="Notes..." />
                  </div> */}
                </div>
                <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column' }}>Moderators</div>
                <MultiSelect
                  data={props.moderators.map(m => { return { ...m, name: `${m.firstName} ${m.lastName}` } })}
                  onChange={(event: MultiSelectChangeEvent) => {
                    setDealerGroupEditInfo(
                      {
                        ...dealerGroupEditInfo,
                        moderatorIds: event.target.value.map(m => m.id)
                      }
                    );
                  }}

                  dataItemKey='id'
                  value={props.moderators.filter(m => dealerGroupEditInfo.moderatorIds.includes(m.id)).map(m => { return { ...m, name: `${m.firstName} ${m.lastName}` } })}
                  fillMode='outline'
                  textField="name"
                  placeholder='moderators...'
                  // label='Moderators'
                  style={{ width: '100%' }}
                />

              </FormElement>
            )}
          />


        </div>


        <WindowActionsBar layout={'stretched'}>
          <button
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
            onClick={() => { props.onCancel() }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
            onClick={() => {
             props.onSubmit(dealerGroupEditInfo);
            }}
          >
            {dealerGroupEditInfo.id ? 'Update' : 'Create'}
          </button>
        </WindowActionsBar>
      </Window>
    </div>
  );
}
